<div class="main-container">
  <form [formGroup]="deviceFotaForm" novalidate>
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        @if (viewMode) {
          <span class="page-title">View/Update Device FOTA Batch</span>
        }
        @if (!viewMode) {
          <span class="page-title">Create New Device FOTA Batch</span>
        }
      </div>
    </div>
    @if (viewFota) {
      <div class="component-container">
        <!-- Component Header Section -->
        <div class="component-header">
          <h6 class="component-title">FOTA Batch Details</h6>
          <div class="component-actions">
            @if (!viewMode && createFota) {
              <button
                class="primary-button"
                type="button"
                (click)="downloadMyFile()"
              >
                Download Sample<mat-icon class="btn-icon">download</mat-icon>
              </button>
            }
          </div>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->

        <div class="component-body">
          <div class="form-section">
            @if (filter === true) {
              <div class="form-group">
                <label for="batchId" class="form-label">FOTA Batch ID</label>
                <mat-form-field appearance="outline">
                  <mat-label>FOTA Batch ID</mat-label>
                  <input
                    placeholder="FOTA Batch ID"
                    formControlName="batchId"
                    matInput
                    type="text"
                    required
                    readonly
                  />
                </mat-form-field>
              </div>
            }

            <div class="form-group">
              <label for="batchName" class="form-label">FOTA Batch Name</label>
              <mat-form-field appearance="outline">
                <mat-label>FOTA Batch Name</mat-label>
                <input
                  placeholder="FOTA Batch Name"
                  formControlName="batchName"
                  matInput
                  type="text"
                  required
                  [readonly]="viewMode"
                />
                @if (
                  deviceFotaForm.controls['batchName'].touched &&
                  deviceFotaForm.controls['batchName'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      deviceFotaForm.controls['batchName'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="form-group">
              <label for="batchDescription" class="form-label"
                >FOTA Batch Description</label
              >
              <mat-form-field appearance="outline">
                <mat-label>FOTA Batch Description</mat-label>
                <input
                  placeholder="FOTA Batch Description"
                  formControlName="batchDescription"
                  matInput
                  type="text"
                  required
                  [readonly]="viewMode"
                />
                @if (
                  deviceFotaForm.controls['batchDescription'].touched &&
                  deviceFotaForm.controls['batchDescription'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      deviceFotaForm.controls['batchDescription'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            @if (!viewMode) {
              <div class="form-group">
                <label for="type" class="form-label">FOTA Type</label>
                <mat-form-field appearance="outline">
                  <mat-label>FOTA Type</mat-label>
                  <mat-select formControlName="type">
                    @for (type of type; track type) {
                      <mat-option [value]="type.value">
                        {{ type.name }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (
                    deviceFotaForm.controls['type'].touched &&
                    deviceFotaForm.controls['type'].errors?.['required']
                  ) {
                    <mat-error> This field is mandatory. </mat-error>
                  }
                </mat-form-field>
              </div>
            }

            @if (filter === true) {
              <div class="form-group">
                <label for="batchDate" class="form-label"
                  >FOTA Batch Date</label
                >
                <mat-form-field appearance="outline">
                  <mat-label>FOTA Batch Date</mat-label>
                  <input
                    placeholder="FOTA Batch Date"
                    formControlName="batchDate"
                    matInput
                    type="text"
                    required
                    readonly
                  />
                  @if (
                    deviceFotaForm.controls['batchDate'].touched &&
                    deviceFotaForm.controls['batchDate'].errors?.['required']
                  ) {
                    <mat-error> This field is mandatory. </mat-error>
                  }
                </mat-form-field>
              </div>
            }
            @if (!viewMode && createFota) {
              <div class="form-group">
                <label for="file" class="form-label">Upload File</label>
                <mat-form-field
                  class="file-upload-container"
                  appearance="outline"
                >
                  <mat-label>Upload File</mat-label>

                  <!-- Display File Name or Placeholder -->
                  <input matInput type="text" formControlName="file" readonly />

                  <!-- Hidden File Input -->
                  <input
                    type="file"
                    accept=".csv"
                    aria-label="File"
                    class="d-none"
                    (change)="onFileChange($event)"
                    #fileInput
                  />

                  <!-- Custom Upload Button -->
                  <button
                    mat-button
                    class="upload-btn"
                    (click)="fileInput.click()"
                    type="button"
                  >
                    <mat-icon>attach_file</mat-icon>
                  </button>

                  @if (
                    deviceFotaForm.controls['file'].touched &&
                    deviceFotaForm.controls['file'].errors?.required
                  ) {
                    <mat-error> This field is mandatory. </mat-error>
                  }
                </mat-form-field>
              </div>
            }
          </div>
        </div>
        @if (!viewMode && createFota) {
          <div class="component-separator"></div>
          <div class="component-footer">
            <div class="button-group">
              <button
                class="submit-button"
                type="button"
                (click)="SubmitBatch()"
                [disabled]="this.deviceFotaForm.invalid"
              >
                Submit <mat-icon class="btn-icon">check_circle</mat-icon>
              </button>
            </div>
          </div>
        }
      </div>
      @if (filter === true) {
        <div class="kpi-section">
          <div
            class="kpi-card kpi-gradient-blue"
            (click)="scrollTo('', totalUploaded)"
            tabindex="0"
            (keydown.enter)="scrollTo('', totalUploaded)"
          >
            <div class="kpi-details">
              <span class="kpi-content">Total Uploaded Devices</span>
              <span class="kpi-value">
                {{ totalUploaded }}
              </span>
            </div>
            <div class="kpi-visual">
              <img
                loading="lazy"
                src="../../assets/uploaded.png"
                alt="device"
              />
            </div>
          </div>
          <div
            class="kpi-card kpi-gradient-yellow"
            (click)="scrollTo('P', NonInitiated)"
            tabindex="0"
            (keydown.enter)="scrollTo('P', NonInitiated)"
          >
            <div class="kpi-details">
              <span class="kpi-content">Total Pending Devices</span>
              <span class="kpi-value">{{ NonInitiated }}</span>
            </div>
            <div class="kpi-visual">
              <img
                loading="lazy"
                src="../../assets/pending.png"
                alt="quality"
              />
            </div>
          </div>
          <div
            class="kpi-card kpi-gradient-purple"
            (click)="scrollTo('I', totalInitiated)"
            tabindex="0"
            (keydown.enter)="scrollTo('I', totalInitiated)"
          >
            <div class="kpi-details">
              <span class="kpi-content">Total Initiated Devices</span>
              <span class="kpi-value">
                {{ totalInitiated }}
              </span>
            </div>
            <div class="kpi-visual">
              <img
                loading="lazy"
                src="../../assets/initiated.png"
                alt="device"
              />
            </div>
          </div>
          <div
            class="kpi-card kpi-gradient-orange"
            (click)="scrollTo('IP', totalInProgress)"
            tabindex="0"
            (keydown.enter)="scrollTo('IP', totalInProgress)"
          >
            <div class="kpi-details">
              <span class="kpi-content">Total In-Progress Devices</span>
              <span class="kpi-value">
                {{ totalInProgress }}
              </span>
            </div>
            <div class="kpi-visual">
              <img
                loading="lazy"
                src="../../assets/in-progress.png"
                alt="device"
              />
            </div>
          </div>
          <div
            class="kpi-card kpi-gradient-pink"
            (click)="scrollTo('A', totalAborted)"
            tabindex="0"
            (keydown.enter)="scrollTo('A', totalAborted)"
          >
            <div class="kpi-details">
              <span class="kpi-content">Total Aborted Devices</span>
              <span class="kpi-value">
                {{ totalAborted }}
              </span>
            </div>
            <div class="kpi-visual">
              <img loading="lazy" src="../../assets/aborted.png" alt="device" />
            </div>
          </div>
          <div
            class="kpi-card kpi-gradient-green"
            (click)="scrollTo('C', totalCompleted)"
            tabindex="0"
            (keydown.enter)="scrollTo('C', totalCompleted)"
          >
            <div class="kpi-details">
              <span class="kpi-content">Total Completed Devices</span>
              <span class="kpi-value">
                {{ totalCompleted }}
              </span>
            </div>
            <div class="kpi-visual">
              <img
                loading="lazy"
                src="../../assets/completed.png"
                alt="device"
              />
            </div>
          </div>
        </div>
        <div class="component-container">
          @if (iSDevices === true) {
            <div class="component-header">
              <h6 class="component-title">Fota Batch Device Details</h6>
              <div class="component-actions">
                @if (viewMode) {
                  <button
                    class="primary-button"
                    [disabled]="
                      fotaBatchDeviceList.length === 0 || isDownloading
                    "
                    (click)="downloadBatchData()"
                  >
                    {{ isDownloading ? 'Downloading...' : 'Export' }}
                    <mat-icon class="btn-icon">download</mat-icon>
                  </button>
                }
                @if (viewMode) {
                  <app-common-search
                    (searchSubmit)="onKeyUpEventBatchList($event)"
                  ></app-common-search>
                }
              </div>
            </div>
          }
          <div class="component-separator"></div>

          @if (iSDevices === true) {
            <div class="component-body">
              <table>
                <thead>
                  <tr>
                    <!-- <th>UIN</th> -->
                    <th>IMEI</th>
                    <th>Fota Type</th>
                    <th>State</th>
                    @if (serverName === 'Sampark') {
                      <th>AF</th>
                    }
                    @if (serverName === 'LCT-A4G') {
                      <th>Open-CPU Version</th>
                      <th>Open-CPU Status</th>
                      <th>Open-CPU Retry Count</th>
                      <th>MCU FOTA Version</th>
                      <th>MCU FOTA Status</th>
                      <th>MCU Retry Count</th>
                      <th>Trigger Order</th>
                    }
                    @if (serverName === 'Sampark') {
                      <th>Device FOTA Version</th>
                      <th>Device FOTA Status</th>
                      <th>FOTA Percentage</th>
                      <th>Retry Count</th>
                      <th>State IP Status</th>
                      <th>State IP Response</th>
                    }
                    <!-- <th>Last Login</th> -->

                    <th>FOTA Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                @if (fotaBatchDeviceList.length > 0) {
                  <tbody>
                    @for (
                      fotaDevicedetail of fotaBatchDeviceList;
                      track fotaDevicedetail
                    ) {
                      <tr>
                        <!-- <td>
                        {{ fotaDevicedetail.uin }}
                      </td> -->
                        <td>{{ fotaDevicedetail.imei }}</td>
                        <td>{{ fotaDevicedetail.fotaType }}</td>
                        <td>{{ fotaDevicedetail.state }}</td>
                        @if (serverName === 'Sampark') {
                          <td>{{ fotaDevicedetail.af }}</td>
                        }

                        @if (serverName === 'LCT-A4G') {
                          <td>{{ fotaDevicedetail.openCpuVer }}</td>
                          <td
                            [ngClass]="{
                              green:
                                fotaDevicedetail.openCpuStatus ===
                                  'FOTA completed' ||
                                fotaDevicedetail.openCpuStatus ===
                                  'Installation Success',
                              red:
                                fotaDevicedetail.openCpuStatus ===
                                  'Installation aborted' ||
                                fotaDevicedetail.openCpuStatus ===
                                  'Download failed' ||
                                fotaDevicedetail.openCpuStatus ===
                                  'Download aborted' ||
                                fotaDevicedetail.openCpuStatus ===
                                  'Download terminated' ||
                                fotaDevicedetail.openCpuStatus ===
                                  'Transfer failed' ||
                                fotaDevicedetail.openCpuStatus ===
                                  'Batch aborted' ||
                                fotaDevicedetail.openCpuStatus ===
                                  'Device login packet not available' ||
                                fotaDevicedetail.openCpuStatus ===
                                  'State not found' ||
                                fotaDevicedetail.openCpuStatus ===
                                  'Firmware not found' ||
                                fotaDevicedetail.openCpuStatus ===
                                  'FOTA Failed',
                            }"
                          >
                            {{ fotaDevicedetail.openCpuStatus }}
                          </td>
                          <td>
                            {{
                              fotaDevicedetail.cpuRetryCount !== null
                                ? fotaDevicedetail.cpuRetryCount
                                : '--'
                            }}
                          </td>
                          <td>{{ fotaDevicedetail.ufw }}</td>
                          <td
                            [ngClass]="{
                              green:
                                fotaDevicedetail.mcuStatus ===
                                  'FOTA completed' ||
                                fotaDevicedetail.mcuStatus ===
                                  'Installation Success',
                              red:
                                fotaDevicedetail.mcuStatus ===
                                  'Installation aborted' ||
                                fotaDevicedetail.mcuStatus ===
                                  'Download failed' ||
                                fotaDevicedetail.mcuStatus ===
                                  'Download aborted' ||
                                fotaDevicedetail.mcuStatus ===
                                  'Download terminated' ||
                                fotaDevicedetail.mcuStatus ===
                                  'Transfer failed' ||
                                fotaDevicedetail.mcuStatus ===
                                  'Batch aborted' ||
                                fotaDevicedetail.mcuStatus ===
                                  'Device login packet not available' ||
                                fotaDevicedetail.mcuStatus ===
                                  'State not found' ||
                                fotaDevicedetail.mcuStatus ===
                                  'Firmware not found' ||
                                fotaDevicedetail.mcuStatus === 'FOTA Failed',
                            }"
                          >
                            {{ fotaDevicedetail.mcuStatus }}
                          </td>
                          <td>
                            {{
                              fotaDevicedetail.mcuRetryCount !== null
                                ? fotaDevicedetail.mcuRetryCount
                                : '--'
                            }}
                          </td>
                          <td>
                            {{
                              fotaDevicedetail.triggerOrder !== null
                                ? fotaDevicedetail.triggerOrder
                                : '--'
                            }}
                          </td>
                        }

                        <!-- <td>{{ fotaDevicedetail.lastlogin }}</td> -->
                        @if (serverName === 'Sampark') {
                          <td>{{ fotaDevicedetail.ufw }}</td>
                          <td
                            [ngClass]="{
                              green:
                                fotaDevicedetail.mcuStatus ===
                                  'FOTA completed' ||
                                fotaDevicedetail.mcuStatus ===
                                  'Installation Success',
                              red:
                                fotaDevicedetail.mcuStatus ===
                                  'Installation aborted' ||
                                fotaDevicedetail.mcuStatus ===
                                  'Download failed' ||
                                fotaDevicedetail.mcuStatus ===
                                  'Download aborted' ||
                                fotaDevicedetail.mcuStatus ===
                                  'Download terminated' ||
                                fotaDevicedetail.mcuStatus ===
                                  'Transfer failed' ||
                                fotaDevicedetail.mcuStatus ===
                                  'Batch aborted' ||
                                fotaDevicedetail.mcuStatus ===
                                  'Device login packet not available' ||
                                fotaDevicedetail.mcuStatus ===
                                  'State not found' ||
                                fotaDevicedetail.mcuStatus ===
                                  'Firmware not found',
                            }"
                          >
                            {{ fotaDevicedetail.mcuStatus }}
                          </td>
                          <td>{{ fotaDevicedetail.fotaPercentage }}</td>
                          <td>
                            {{
                              fotaDevicedetail.mcuRetryCount !== null
                                ? fotaDevicedetail.mcuRetryCount
                                : '--'
                            }}
                          </td>
                          <td
                            [ngClass]="{
                              green:
                                fotaDevicedetail.stateIpStatus ===
                                'All IP sent',
                            }"
                          >
                            {{
                              fotaDevicedetail.stateIpStatus !== null
                                ? fotaDevicedetail.stateIpStatus
                                : '-'
                            }}
                          </td>
                          <td>{{ fotaDevicedetail.stateIpRes }}</td>
                        }
                        <td
                          [ngClass]="{
                            green:
                              fotaDevicedetail.overallFotaStatus ===
                              'FOTA completed',
                            red:
                              fotaDevicedetail.overallFotaStatus ===
                                'FOTA Failed' ||
                              fotaDevicedetail.overallFotaStatus ===
                                'Download aborted',
                          }"
                        >
                          {{ fotaDevicedetail.overallFotaStatus }}
                        </td>
                        <td>
                          <div class="action-buttons">
                            @if (deleteFota) {
                              <button
                                class="primary-button abort-button"
                                [disabled]="
                                  fotaDevicedetail.overallFotaStatus ===
                                    'FOTA completed' ||
                                  fotaDevicedetail.overallFotaStatus ===
                                    'FOTA Failed' ||
                                  fotaDevicedetail.overallFotaStatus ===
                                    'Download aborted' ||
                                  fotaDevicedetail.overallFotaStatus ===
                                    'Download failed' ||
                                  fotaDevicedetail.overallFotaStatus ===
                                    'Transfer failed' ||
                                  fotaDevicedetail.overallFotaStatus ===
                                    'Batch aborted'
                                "
                                (click)="abort(fotaDevicedetail.id)"
                              >
                                <mat-icon class="btn-icon">block</mat-icon>
                              </button>
                            }
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                }
                @if (fotaBatchDeviceList.length === 0) {
                  <tbody>
                    <tr>
                      <td colspan="13" style="text-align: center">
                        <img
                          loading="lazy"
                          class="no-data-img"
                          src="../../assets/dataNotFound.jpg"
                          alt="No Data Found"
                          style="display: block; margin: 0 auto"
                        />
                      </td>
                    </tr>
                  </tbody>
                }
              </table>
            </div>
          }

          @if (iSDevices === true && startFotaFlag === 'Y' && updateFota) {
            <div class="component-separator"></div>
            <div class="component-footer pt-0 pb-0">
              <div class="button-group">
                <button class="submit-button" (click)="startFota()">
                  Start FOTA<mat-icon class="btn-icon">check_circle</mat-icon>
                </button>
              </div>
            </div>
          }

          <div class="component-separator"></div>
          @if (iSDevices === true) {
            <div class="component-footer">
              @if (fotaBatchDeviceList.length > 0) {
                <app-common-component-pagination
                  [totalItems]="totalCount"
                  [pageSize]="pageSize"
                  [currentPage]="currentPage"
                  (pageChange)="onPageChange($event)"
                  (sizeChange)="onSizeChange($event)"
                >
                </app-common-component-pagination>
              }
            </div>
          }
        </div>
      }
    }
  </form>
</div>
